import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import AllCashFunds from "../components/Cashfund/AllCashFunds";
import Footer from "../components/Footer";

const HomePage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

 
  return (
    <div style={{ minHeight: "100vh", position: "relative" ,background : "#ffda6a"}}>
         <Navbar/>
   <AllCashFunds />
<Footer />
    </div>
  );
};

export default HomePage;
